const swapOverUnderClients = [
  'betonalfa', 'opapsports', 'opap', 'betlive2', 'luckyland', 'sisal', 'nsoftsuperbet', 'fortuna', 'cybet', 'totolotekcashpoint', 'totolotek', 'bbetpoint', 'dafabet', 'luckiaes',
];

export default swapOverUnderClients;
